/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_PrivacyInputs */

const cs_youtube_export_privacy = /** @type {(inputs: Youtube_Export_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viditelnost na YouTube`)
};

const en_youtube_export_privacy = /** @type {(inputs: Youtube_Export_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube visibility`)
};

/**
* | output |
* | --- |
* | "YouTube visibility" |
*
* @param {Youtube_Export_PrivacyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_privacy = /** @type {((inputs?: Youtube_Export_PrivacyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_PrivacyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_privacy(inputs)
	return cs_youtube_export_privacy(inputs)
});